import { createContext } from 'react';
import { ISession } from '../interfaces/IContext';

interface ISessionContext {
    session: ISession;
    setSession: (session: ISession) => void;
}

const SessionContext = createContext<ISessionContext>({
    session: {
        azureId: '',
        codEmp: 0,
        exp: 0,
        groups: [],
        iat: 0,
        userAzure: ''
    },
    setSession: () => {}
});

export default SessionContext;
